<template>
  <v-dialog
    persistent
    v-model="isShow"
    max-width="290"
  >
    <v-card
      style="border-radius: 24px"
    >
      <v-card-title
        class="ma-0 pa-0"
      >
        <div
          style="height: 54px;width:100%;position: relative"
        >
          <div
            class="caption text-center card-title"
          >{{ title }}
          </div>
          <svg
            class="close-button"
            @click="isShow = false"
            width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.3 0.709956C13.1131 0.522704 12.8595 0.417471 12.595 0.417471C12.3305 0.417471 12.0768 0.522704 11.89 0.709956L6.99997 5.58996L2.10997 0.699956C1.92314 0.512704 1.66949 0.407471 1.40497 0.407471C1.14045 0.407471 0.886802 0.512704 0.699971 0.699956C0.309971 1.08996 0.309971 1.71996 0.699971 2.10996L5.58997 6.99996L0.699971 11.89C0.309971 12.28 0.309971 12.91 0.699971 13.3C1.08997 13.69 1.71997 13.69 2.10997 13.3L6.99997 8.40996L11.89 13.3C12.28 13.69 12.91 13.69 13.3 13.3C13.69 12.91 13.69 12.28 13.3 11.89L8.40997 6.99996L13.3 2.10996C13.68 1.72996 13.68 1.08996 13.3 0.709956Z" fill="#929191"/>
          </svg>
        </div>
      </v-card-title>
      <v-card-text
        style="text-align:center"
      >
        {{ description }}
        <div
          style="margin:16px auto 32px auto"
        >
          <svg width="109" height="72" viewBox="0 0 109 72" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99998 21.5114C9.17331 20.1381 11.3466 19.5781 13.1066 20.7781C14.04 21.4181 14.6266 22.4981 14.6666 23.6314C14.7533 26.2181 12.4666 28.2914 8.96665 31.4648L8.89331 31.5314C8.38665 31.9981 7.60665 31.9981 7.09998 31.5381L7.03331 31.4781L6.99305 31.4415C3.51574 28.2822 1.24034 26.2148 1.33331 23.6381C1.37331 22.4981 1.95998 21.4181 2.89331 20.7781C4.65331 19.5714 6.82665 20.1381 7.99998 21.5114ZM7.99997 30.5514L8.06664 30.4848C11.24 27.6114 13.3333 25.7114 13.3333 23.7848C13.3333 22.4514 12.3333 21.4514 11 21.4514C9.9733 21.4514 8.9733 22.1114 8.62664 23.0248H7.37997C7.02664 22.1114 6.02664 21.4514 4.99997 21.4514C3.66664 21.4514 2.66664 22.4514 2.66664 23.7848C2.66664 25.7114 4.75997 27.6114 7.9333 30.4848L7.99997 30.5514Z" fill="#FF8040"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M101 8.51145C102.173 7.13811 104.347 6.57811 106.107 7.77811C107.04 8.41811 107.627 9.49811 107.667 10.6314C107.753 13.2181 105.467 15.2914 101.967 18.4648L101.893 18.5314C101.387 18.9981 100.607 18.9981 100.1 18.5381L100.033 18.4781L99.993 18.4415C96.5157 15.2822 94.2403 13.2148 94.3333 10.6381C94.3733 9.49811 94.96 8.41811 95.8933 7.77811C97.6533 6.57145 99.8266 7.13811 101 8.51145ZM101 17.5514L101.067 17.4848C104.24 14.6114 106.333 12.7114 106.333 10.7848C106.333 9.45144 105.333 8.45144 104 8.45144C102.973 8.45144 101.973 9.11144 101.627 10.0248H100.38C100.027 9.11144 99.0266 8.45144 98 8.45144C96.6666 8.45144 95.6666 9.45144 95.6666 10.7848C95.6666 12.7114 97.76 14.6114 100.933 17.4848L101 17.5514Z" fill="#FF8040"/>
          <path d="M85.7554 15.7281C85.1137 14.7921 84.4414 13.8933 83.7207 13.0276C77.1157 5.0625 67.1489 0 56 0C44.8511 0 34.8843 5.0625 28.2793 13.0276C27.5586 13.8933 26.8863 14.7921 26.2446 15.7281C22.3071 21.498 20 28.4722 20 36C20 43.5147 22.3071 50.4887 26.2315 56.261C26.8732 57.1949 27.5499 58.0957 28.2706 58.9614C34.8711 66.9243 44.8401 72 56 72C67.1599 72 77.1289 66.9243 83.7317 58.9614C84.4501 58.0957 85.127 57.1947 85.7685 56.261C89.6929 50.4887 92 43.5147 92 36C92 28.4722 89.6929 21.498 85.7554 15.7281ZM85.1797 37.837L74.5098 39.4674C74.5098 39.4674 71.9301 46.2393 74.1363 47.1205C81.6355 50.122 76.3863 55.6173 71.1348 57.997C68.7837 59.0626 69.2165 60.5611 70.8492 61.1764C66.4941 63.7602 61.4184 65.25 56 65.25C47.1911 65.25 39.2942 61.3344 33.9262 55.1579C33.1747 54.3032 32.476 53.3935 31.8235 52.4486C29.5207 49.0781 27.9234 45.1977 27.1983 41.0273C28.1893 40.0868 29.3296 39.2079 30.3316 38.54C32.7398 36.9315 37.1585 34.5233 37.1585 28.0963C37.1585 21.6714 41.5772 22.0736 41.5772 22.0736H43.5855L41.8848 26.121L46.0113 25.7475L49.6104 19.2611L56.8394 15.6466C56.8394 15.6466 61.3855 9.6217 56.8394 9.62395C55.7188 9.62395 47.9757 9.62395 43.3789 9.62395C47.2022 7.78711 51.4824 6.75 56 6.75C61.5503 6.75 66.7535 8.31009 71.1809 11.0128C70.4316 10.8809 69.6714 10.782 68.8848 10.7468L62.8906 11.5005V17.1167L67.1402 17.3386C70.1328 17.4946 72.6113 19.7094 73.0992 22.6626L74.1363 28.9028L85.0128 35.1958L85.2501 36.0066C85.25 36.6218 85.2171 37.2305 85.1797 37.837Z" fill="#FFAA80"/>
          <path d="M50.6848 47.6104V48.9551H46.5759V47.2148L40.729 51.482V57.252H49.0259L50.0543 58.9922H53.4512L55.9802 56.5401V52.1938L51.9505 47.6104H50.6848Z" fill="#FFAA80"/>
          <path d="M42.6165 41.8052C42.1968 41.8052 41.854 42.2008 41.854 42.6884V43.0993C41.854 43.5849 42.1968 43.9826 42.6165 43.9826H44.2183C44.6402 43.9826 44.983 43.5849 44.983 43.0993V42.6884C44.983 42.2006 44.6402 41.8052 44.2183 41.8052H42.6165Z" fill="#FFAA80"/>
          <path d="M39.9289 39.6587H37.9996H37.8677C37.4459 39.6587 37.103 40.0564 37.103 40.5442V41.7658C37.103 42.2536 37.3007 42.6491 37.637 42.6491H37.7205C38.083 42.6491 37.9995 43.0447 37.9995 43.5368V44.1082C37.9995 44.596 38.3423 44.9915 38.7642 44.9915H39.9287C40.3506 44.9915 40.6889 44.5959 40.6889 44.1082V42.6492V40.5442C40.6891 40.0564 40.3507 39.6587 39.9289 39.6587Z" fill="#FFAA80"/>
          <path d="M40.7817 38.3247H40.9355C41.3574 38.3247 41.7002 38.7224 41.7002 39.2125V39.652C41.7002 40.1398 42.0431 40.5352 42.4627 40.5352H48.3712C48.7316 40.5352 49.0392 40.2451 49.1183 39.8408L50.3532 33.2885C50.4015 33.0249 50.3466 32.7523 50.2016 32.5436C50.0566 32.335 49.839 32.2119 49.6062 32.2119H47.4704C47.1122 32.2119 46.8024 32.502 46.7277 32.9107L46.3015 35.1892C46.2246 35.5958 45.9148 35.888 45.5543 35.888H40.7818C40.3599 35.888 40.0171 36.2813 40.0171 36.7713V37.4415C40.0171 37.9293 40.3598 38.3247 40.7817 38.3247Z" fill="#FFAA80"/>
          <path d="M48.1073 31.01H51.4208C51.79 31.01 52.102 30.7089 52.1724 30.2916L52.6513 27.378C52.6931 27.1187 52.6337 26.8506 52.4888 26.6484C52.3438 26.4462 52.1283 26.3276 51.8998 26.3276H48.5863C48.2215 26.3276 47.9051 26.6308 47.837 27.0483L47.358 29.9597C47.3163 30.2168 47.3734 30.4848 47.5206 30.6893C47.6635 30.8936 47.8788 31.01 48.1073 31.01Z" fill="#FFAA80"/>
          <path d="M93.3332 29.3332H90.6665L83.9998 39.9998H76.6665C75.5598 39.9998 74.6665 40.8932 74.6665 41.9998C74.6665 43.1065 75.5598 43.9998 76.6665 43.9998H83.9998L90.6665 54.6665H93.3332L89.9998 43.9998H97.3332L99.3332 46.6665H101.333L99.9998 41.9998L101.333 37.3332H99.3332L97.3332 39.9998H89.9998L93.3332 29.3332Z" fill="#FF5500"/>
          </svg>
        </div>
      <btn
        class="mx-0 mb-0"
        @click="click"
        text="Sign Up & Log In"
      ></btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import btn from '@/components/Like/Button'

export default {
  components: {
    btn,
  },
  props: {
    title: { type: String, required: true },
    description: { type: String, required: true, },
  },
  data: () => ({
    isShow: false,
  }),
  methods: {
    show() {
      this.isShow = true
    },
    click() {
      this.$emit('click')
      this.isShow = false
    }
  },
}
</script>

<style lang="stylus" scoped>
div.card-title
  height 54px
  line-height 54px
  width 100%
  text-align center
  font-size 17px !important
svg.close-button
  position absolute
  right 21px
  top 21px
</style>